// <head> metadata for ConductorLicensePage (https://www.dbos.dev/conductor-license).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Conductor Software License',
    },
    {
      name: 'description',
      content: 'Software license for DBOS Conductor',
    },
    {
      property: 'og:title',
      content: 'Conductor Software License',
    },
    {
      property: 'og:description',
      content: 'Software license for DBOS Conductor',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Conductor Software License',
    },
    {
      name: 'twitter:description',
      content: 'Software license for DBOS Conductor',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/conductor-license',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
